/* eslint-disable react-hooks/exhaustive-deps */
export default function ModalSendValidation({modalData, setModalData, handleSubmit}) {
    const closeModal = () => {
        setModalData({
            show: null,
            data: null
        })
    }
    const handleSend = () => {
        closeModal()
        handleSubmit()
    }

    return (
        <div className={modalData.show ? 'modal-wrapper active' : 'modal-wrapper'}>
            <div className="modal modal-tipo-pago">
                <div className="head">
                    <h3>Subir comprobantes</h3>
                    <button onClick={closeModal}>
                        x
                    </button>
                </div>
                <div className="content">
                        <div>
                            <label>Si ya no va a subir otro comprobante de pago, se enviará a validar a Cemefi</label>
                        </div>
                </div>
                <div className="actions">
                    <button onClick={closeModal}>Subir otro comprobante</button>
                    <button onClick={handleSend}>Enviar a validar</button>
                </div>
            </div>
        </div>
    )
}